import React, { useState } from 'react';
import { ShareNetwork, Link as LinkIcon, X as XLogo, Check } from '@phosphor-icons/react';
import { toast } from 'sonner';

export function ShareButtons({ title, url }) {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Link copied!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Failed to copy');
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="text-xs font-bold text-[#5C7A99] uppercase tracking-wide">Share</span>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank" rel="noopener noreferrer"
        className="w-8 h-8 rounded-lg border-2 border-[#004E89] bg-[#1877F2] flex items-center justify-center hover:-translate-y-0.5 transition-transform shadow-[2px_2px_0px_#004E89]"
        data-testid="share-facebook"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
      </a>
      <a
        href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
        target="_blank" rel="noopener noreferrer"
        className="w-8 h-8 rounded-lg border-2 border-[#004E89] bg-black flex items-center justify-center hover:-translate-y-0.5 transition-transform shadow-[2px_2px_0px_#004E89]"
        data-testid="share-twitter"
      >
        <XLogo size={14} weight="bold" className="text-white" />
      </a>
      <button
        onClick={copyLink}
        className={`w-8 h-8 rounded-lg border-2 border-[#004E89] flex items-center justify-center hover:-translate-y-0.5 transition-all shadow-[2px_2px_0px_#004E89] ${copied ? 'bg-[#4CB944]' : 'bg-white'}`}
        data-testid="share-copy-link"
      >
        {copied ? <Check size={14} weight="bold" className="text-white" /> : <LinkIcon size={14} weight="bold" className="text-[#004E89]" />}
      </button>
    </div>
  );
}
